import { useClientOnlyMediaQuery } from '~/common/hooks/use-client-only-media-query';
import type { StoryOverview } from '~/common/types/story-overview';
import { Media } from '~/utils/styles/enums';
import { usePaywall } from './use-paywall-hooks';

export const useLocalHooks = (story: StoryOverview) => {
  const screenLarge = useClientOnlyMediaQuery(Media.LARGE);
  const isMobile =
    typeof screenLarge === 'undefined' ? undefined : !screenLarge;

  const paywallHooks = usePaywall(story);

  return {
    isMobile,
    paywallHooks,
  };
};
